import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../../styles/proposition-bets-widget.module.scss";
import {EntityLogo} from "../../../../../core/components/logos/entity-logo";
import {PropositionBetsWidgetRowAthleteDetails} from "./proposition-bets-widget.row.athlete-details";

export const PropositionBetsWidgetRowAthlete = observer(({row}) => {
  const {athlete} = row;

  const logoProps = {
    entity: athlete,
    width: 40,
    height: 40
  }

  return (
    <div className={classNames(styles.athlete)}>
      <div className={classNames(styles.athlete_logo)}>
        <EntityLogo {...logoProps}/>
      </div>
      <PropositionBetsWidgetRowAthleteDetails row={row}/>
    </div>
  )
});
